<template>
  <div class="image-gallery-title" :class="{ center: center, 'mw-adjusted-align-center': center }">
    <h2 v-if="title && showTitle" class="header-default light article-social-club-heading new-pdp-title ctf-heading ctf-restrict">
      {{ title }}
    </h2>
    <p class="subtitle-default ctf-body">
      <slot name="subtitle">Show us your Articles using <strong>#OurArticle</strong> and make sure you tag us <strong>@article</strong>.</slot>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Article, In Real Life',
    },
    center: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="postcss">
$ugc-mobile-breakpoint: 845px;

.image-gallery-title {
  &.center {
    text-align: center;
    .subtitle-default {
      padding: 0px 4px;
    }
  }

  .subtitle-default {
    margin-top: 12px;
    margin-bottom: 12px;
    color: var(--grey-medium);
    font-size: var(--font-size-16);
  }
}
</style>
